'use client'

// Clutch's _rscLayout imports globals.scss *after* LayoutClient, so its base classes
// (`.p`, `.layer-*`) land later in the cascade than the component CSS modules that override
// them at equal specificity - which silently kills those overrides on the app router. The
// pages router doesn't hit this because Next hoists global CSS imported from _app.
// Importing it from a client module that the layout pulls in first puts it ahead of
// LayoutClient in the client CSS bundle. Delete this once Clutch imports globals first.
import 'Styles/globals.scss'

export default function ClutchGlobals() {
  return null
}
